export { default as AdminListListMobile } from './AdminListListMobile';

export type {
  AdminListListMobileProps,
  AdminListListMobileComponent,
} from './AdminListListMobile.type';
